import classNames from 'classnames'
import { WizardStepProperties } from 'components/types'
import { ChangeEvent, FocusEvent, useEffect, useRef, useState } from 'react'
import { IconSizes, CustomColorsRef } from 'types/general'

import IconRender from '../IconRender'
import FieldErrorMessage from './FieldErrorMessage'
import { fieldInputClass } from './fieldInputStyles'

const TextInput = ({
  name,
  label,
  value,
  errorMessage,
  required,
  isFirstInput,
  onChange,
  setIsValid,
  customFieldStyle,
  readOnly,
  highlight,
  customIcon,
}: WizardStepProperties) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isValidField, setIsValidField] = useState(true)
  const [isFocused, setIsFocused] = useState(false)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, type, value } = e.target
    onChange({ name, type, value })
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    const value = e.target.value.trim()
    setIsFocused(false)

    if (!required && value === '') {
      setIsValidField(true)
      setIsValid?.(true)
    } else if (required && value !== '') {
      setIsValidField(true)
      setIsValid?.(true)
    } else {
      setIsValidField(false)
      setIsValid?.(false)
    }
  }

  const handleFocus = () => {
    setIsFocused(true)
  }

  useEffect(() => {
    if (isFirstInput && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isFirstInput])

  return (
    <div className="my-2">
      <label
        htmlFor={name}
        className="block text-imovSecondaryDark font-bold pl-1 mb-0.5 text-md sm:text-base"
      >
        {label}
      </label>
      <div className="relative">
        {customIcon && (
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <IconRender
              icon={customIcon}
              size={IconSizes.LG}
              color={
                isFocused || highlight
                  ? CustomColorsRef.PrimaryLight
                  : CustomColorsRef.Gray
              }
            />
          </span>
        )}
        <input
          type="text"
          ref={inputRef}
          id={name}
          name={name}
          value={value as string}
          required={required}
          readOnly={readOnly}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          className={classNames(
            fieldInputClass({ withIcon: Boolean(customIcon) }),
            customFieldStyle
          )}
        />
      </div>
      <FieldErrorMessage
        hasError={!isValidField}
        message={errorMessage}
        className="ml-2"
      />
    </div>
  )
}

export default TextInput
